import React from 'react'
import styles from './MakePayment.module.css'
import { FaHome } from 'react-icons/fa';
import adlogo from '../Images/AdManagerLogo.png'
import Billlogo from '../Images/BillingLogo.png'
import Billl from '../Images/arrorwright.png'
import { Link } from "react-router-dom";
import visa from '../Images/visa.png'
import visa1 from '../Images/visa1.png'


const MakePayment = () => {
  return (
    <>
       <div className={styles.home}>
                <div className={styles.side}>
                    <div>
                        <Link to="/home" className={styles.homeTitle}>
                            <FaHome size={22} className={styles.logo} />
                            <div className={styles.text}>Home</div>
                        </Link>
                        <Link to="/admanager"  className={styles.manager}>
                            <div className={styles.admanag}><img src={adlogo} alt="" /></div>
                            <div className={styles.text}>Ad manager</div>
                            </Link>
                            <Link to="/billing" className={styles.manager1}>
                            <div className={styles.admanag}><img src={Billlogo} alt="" /></div>
                            <div className={styles.text}>Billing</div>
                            </Link>
                    </div>
                    <div className={styles.mail}>
                        <div className={styles.amy}>
                            <div className={styles.hors}>Amy Horsefighter</div>
                            <div className={styles.fighter}>ahorsefighter@gmail.com</div>
                        </div>
                        <img src={Billl} alt="" className={styles.butts} />
                    </div>

                </div>
                <div className={styles.right}>
                    <div className={styles.inner}>
                       <div className={styles.paymentDetail}>
                        <div className={styles.paymentArea}>
                            <div className={styles.paymentHead}>
                                <div className={styles.paymentHeading}>Payment</div>
                                <div className={styles.secure}>All transactions are secure and encrypted</div>
                                <div className={styles.credit}>
                                    <div className={styles.card}><input type="radio" className={styles.checkinput}/> <div className={styles.creditText}>Credit card</div></div>
                                    <div className={styles.visaArae}><img src={visa} className={styles.visaaa} alt="" /> <img src={visa1} style={{marginLeft:"14px"}} alt="" /></div>
                                </div>
                            </div>
                            <div className={styles.detail}>
                                <div className={styles.bitcoin}>
                                    <div className={styles.via}>
                                        <input type="radio" className={styles.checkinput}/>
                                        <div className={styles.coin}>Bitcoin via COINQVEST</div>
                                    </div>
                                </div>
                                <div className={styles.curruncy}>
                                    <div className={styles.curr}>Pay with Bitcoin and other digital currencies (ETH, LTC, XLM, XRP) via COINQVEST</div>
                                </div>
                            </div>
                        </div>
                       </div>
                       <div className={styles.calculation}>
                        <div className={styles.apply}>
                            <div className={styles.code}>
                                <input type="text" placeholder='Discount code' className={styles.discount} />
                                <button className={styles.applyButton}>Apply</button>
                            </div>
                            <div className={styles.line}></div>
                            <div className={styles.subtotal}>
                                <div className={styles.subHeading}>Subtotal</div>
                                <div className={styles.subHeading}>$19,99</div>
                            </div>
                            <div className={styles.subtotal}>
                                <div className={styles.subHeading}>Shipping</div>
                                <div className={styles.subHeading}>$19,99</div>
                            </div>
                            <div className={styles.line1}></div>
                            <div className={styles.subtotal}>
                                <div>
                                    <div className={styles.total}>Total</div>
                                    <div className={styles.inclu}>Includin $3,51 in taxes</div>
                                </div>
                                <div className={styles.payable}>$22,47</div>
                            </div>
                        </div>
                       </div>

                    </div>
                </div>
            </div>
    </>
  )
}

export default MakePayment
